"use client";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackAnalyticsEvent } from "@/services/api/client";

const PATH_TO_PAGE: Record<string, "home" | "book" | "event"> = {
  "/": "home",
  "/book": "book",
  "/event": "event",
};

/** One page_view per route change; dedupe in trackAnalyticsEvent handles StrictMode. */
export function AnalyticsRouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PATH_TO_PAGE[pathname];
    if (page) void trackAnalyticsEvent("page_view", page);
  }, [pathname]);
  return null;
}
